import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosComman";

function useGetDropDown({ url,create=false,value="" }) {
  const [dropDownValue, setDropDownValue] = useState([]);
  const [loading, setLoading] = useState(false);
  async function getData() {
    setLoading(true);
    await axiosInstance
      .get(url)
      .then((res) => {
        let data = res?.data?.data;
        let xyz = [];
        if(create == true){
            setDropDownValue(data);
        }else{
          data.forEach((i) => {
            let x = { label: i[value], value: i[value] };
            xyz.push(x);
          });
          res?.data && setDropDownValue(xyz);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }
  useEffect(() => {
    if (url) getData();
  }, [url]);
  return { dropDownValue, getData,loading };
}

export default useGetDropDown;
